(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_collection--filter--clear"] && !Shopify.designMode) return;
  try {
    (function initFilterClear() {
  function hasActiveFilters() {
    for (const [key] of new URLSearchParams(window.location.search)) {
      if (key.startsWith('filter.')) return true;
    }
    return false;
  }

  function updateVisibility() {
    const active = hasActiveFilters();
    for (const el of document.querySelectorAll('[data-filter-clear]')) {
      el.hidden = !active;
    }
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-filter-clear]')) return;
    document.dispatchEvent(new CustomEvent('filter:clear', { bubbles: true }));
  });

  document.addEventListener('filter:applied', () => setTimeout(updateVisibility, 50));
  document.addEventListener('filter:cleared', () => setTimeout(updateVisibility, 50));
  window.addEventListener('popstate', () => setTimeout(updateVisibility, 50));

  updateVisibility();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_collection--filter--count"] && !Shopify.designMode) return;
  try {
    /**
 * Updates all filter-count elements when filters change.
 * Uses multiple strategies to ensure count stays in sync.
 */
(function initFilterCount() {
  /**
   * Count active filters from URL params (most reliable after AJAX)
   * @returns {number}
   */
  function countFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    let count = 0;
    for (const [key] of params) {
      // Filter params typically start with 'filter.'
      if (key.startsWith('filter.')) {
        count++;
      }
    }
    return count;
  }

  /**
   * Count active filters from form checkboxes (for pending changes)
   * @returns {number}
   */
  function countFiltersFromForm() {
    const filterForm = document.querySelector('collection-filters [ref="form"]');
    if (!filterForm) return 0;
    return filterForm.querySelectorAll('input[type="checkbox"]:checked').length;
  }

  /**
   * Update all filter count displays
   * @param {boolean} [useUrl=false] - Use URL params instead of form state
   */
  function updateAllFilterCounts(useUrl = false) {
    const filterCountElements = document.querySelectorAll('[data-filter-count]');
    if (filterCountElements.length === 0) return;

    const count = useUrl ? countFiltersFromUrl() : countFiltersFromForm();
    const displayText = count > 0 ? `(${count})` : '';

    for (const el of filterCountElements) {
      el.textContent = displayText;
    }
  }

  // Listen for filter form changes (pending changes before apply)
  document.addEventListener('change', (event) => {
    if (event.target.closest('collection-filters [ref="form"]')) {
      updateAllFilterCounts(false);
    }
  });

  // Listen for filter applied (filters fetched and grid updated)
  document.addEventListener('filter:applied', () => {
    setTimeout(() => updateAllFilterCounts(true), 50);
  });

  // Listen for filters cleared
  document.addEventListener('filter:cleared', () => {
    setTimeout(() => updateAllFilterCounts(true), 50);
  });

  // Reset to URL count when an overlay closes (handles close-without-apply)
  // Capture phase because dialog close events don't bubble
  document.addEventListener('close', (event) => {
    if (event.target.closest('overlay-component')) {
      updateAllFilterCounts(true);
    }
  }, true);

  // Also update on popstate (browser back/forward)
  window.addEventListener('popstate', () => {
    setTimeout(() => updateAllFilterCounts(true), 50);
  });

  // Initial sync from URL on page load
  updateAllFilterCounts(true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["header--sticky"] && !Shopify.designMode) return;
  try {
    const header = document.querySelector('[data-transparent-header]');
  if (header) {
    const trigger = header.dataset.scrollTrigger || 'scroll';
    const heroEl = trigger === 'hero_bottom' ? document.querySelector('[data-header-trigger]') : null;

    let observeTarget = heroEl;
    let rootMargin = '0px';

    if (heroEl) {
      // Shrink the observer's root by the header's own height, so the
      // callback fires once the header has fully cleared the hero —
      // not just once the hero starts leaving the viewport.
      rootMargin = `-${header.offsetHeight}px 0px 0px 0px`;
    } else {
      // 'scroll' mode, or 'hero_bottom' with no block opted in via
      // [data-header-trigger] — fall back to the original top-of-page
      // sentinel (fires on first scroll).
      observeTarget = document.createElement('div');
      observeTarget.setAttribute('aria-hidden', 'true');
      document.body.prepend(observeTarget);
    }

    new IntersectionObserver(([entry]) => {
      header.classList.toggle('header--scrolled', !entry.isIntersecting);
    }, { rootMargin }).observe(observeTarget);
  }
  } catch(e) { console.error(e); }
})();

})();
